export default __webpack_public_path__ + "static/media/acura.263b3a09.png";